import * as React from 'react';
import { useOrderDetailsSummariesSlot, DeliveryMethod } from '@grandvisionhq/fun-orders';
import { Hooks as Hooks$1 } from '@grandvisionhq/pickup-points';
import { Hooks } from '@grandvisionhq/stores-v2';
import { useCheckoutSettings } from '../../../../context/CheckoutSettings/context.js';
import { getShippingMethodInfo } from '../../../../utils/get-shipping-method-info.js';

const useOrderDetails = (orderData, shippingMethodsAsides, labels)=>{
    var ref6, ref1, ref2, ref3, ref4, ref5;
    const orderDetailsSummaries = useOrderDetailsSummariesSlot(orderData);
    const [pickupLocation, setPickupLocation] = React.useState();
    const [storeDetailsQuery, storeDetailsQueryState] = Hooks.useStoreDetails();
    const [getPickupPoints, pickupPointsQueryState] = Hooks$1.useGetPickupPoints();
    const pickupLocationCode = orderData === null || orderData === void 0 ? void 0 : (ref6 = orderData.shippingAddress) === null || ref6 === void 0 ? void 0 : ref6.externalId;
    const showInvoiceDetails = (orderData === null || orderData === void 0 ? void 0 : (ref1 = orderData.invoice) === null || ref1 === void 0 ? void 0 : ref1.customerCode) || (orderData === null || orderData === void 0 ? void 0 : (ref2 = orderData.invoice) === null || ref2 === void 0 ? void 0 : ref2.secondaryEmail) || (orderData === null || orderData === void 0 ? void 0 : (ref3 = orderData.invoice) === null || ref3 === void 0 ? void 0 : ref3.customerVatId);
    const isPickupStoreDelivery = (orderData === null || orderData === void 0 ? void 0 : orderData.deliveryMethod) === DeliveryMethod.Pickup;
    const isPickupPointDelivery = (orderData === null || orderData === void 0 ? void 0 : orderData.deliveryMethod) === DeliveryMethod.PickupPoint;
    const isPickupDelivery = isPickupStoreDelivery || isPickupPointDelivery;
    const { features  } = useCheckoutSettings();
    const shippingMethodInfo = getShippingMethodInfo(labels.summary, orderData === null || orderData === void 0 ? void 0 : orderData.deliveryMethod, shippingMethodsAsides);
    React.useEffect(()=>{
        if (pickupLocationCode && isPickupStoreDelivery) {
            storeDetailsQuery(parseInt(pickupLocationCode, 10));
        }
    }, [
        isPickupStoreDelivery,
        pickupLocationCode,
        storeDetailsQuery
    ]);
    React.useEffect(()=>{
        if (pickupLocationCode && isPickupPointDelivery) {
            // I case of pickup point there is no query availble yet to get a pickup point by code.
            // So for now we fetch 20 pickuppoint by using the postalCode and than filter the pickup point by using the store code in the shipping address
            getPickupPoints({
                formState: {
                    postalCode: orderData === null || orderData === void 0 ? void 0 : orderData.shippingAddress.postalCode,
                    city: (orderData === null || orderData === void 0 ? void 0 : orderData.shippingAddress.city) || ''
                }
            });
        }
    }, [
        getPickupPoints,
        isPickupPointDelivery,
        orderData === null || orderData === void 0 ? void 0 : (ref4 = orderData.shippingAddress) === null || ref4 === void 0 ? void 0 : ref4.city,
        orderData === null || orderData === void 0 ? void 0 : (ref5 = orderData.shippingAddress) === null || ref5 === void 0 ? void 0 : ref5.postalCode,
        pickupLocationCode,
        storeDetailsQuery, 
    ]);
    React.useEffect(()=>{
        var ref;
        // Set Pickup location in case of in-store-pickup delivery
        if (storeDetailsQueryState.data) {
            setPickupLocation(storeDetailsQueryState.data);
        }
        // Set Pickup location in case of pickup point delivery
        if (pickupPointsQueryState === null || pickupPointsQueryState === void 0 ? void 0 : (ref = pickupPointsQueryState.pickupPoints) === null || ref === void 0 ? void 0 : ref.length) {
            // Find the pickup point which matches the store code (externalId)
            const selectedPickupPoint = pickupPointsQueryState.pickupPoints.find((pickupPoint)=>pickupPoint.code === Number(pickupLocationCode)
            );
            if (selectedPickupPoint) {
                setPickupLocation(selectedPickupPoint);
            }
        }
    }, [
        pickupLocationCode,
        pickupPointsQueryState.pickupPoints,
        storeDetailsQueryState.data
    ]);
    return {
        labels,
        shippingMethodInfo,
        isPickupDelivery,
        pickupLocation,
        orderDetailsSummaries,
        showInvoiceDetails,
        features
    };
};

export { useOrderDetails };
//# sourceMappingURL=use-order-details.js.map
